/*
 * MSC cart drawer. Markup lives in snippets/msc-cart-drawer.liquid; contents are
 * re-rendered server side via the Section Rendering API (msc-cart-drawer-items)
 * so Liquid stays the single source for prices, discounts and currency.
 */
(function () {
  if (window.MSCCart) return;

  var SECTION = 'msc-cart-drawer-items';
  var root = document.querySelector('[data-msc-cart]');
  if (!root) return;

  var routes = (window.Shopify && window.Shopify.routes) || {};
  var rootUrl = routes.root || '/';
  var sheet = root.querySelector('.msc-cart__sheet');
  var fab = root.querySelector('[data-msc-cart-open]');
  var body = root.querySelector('[data-msc-cart-body]');
  var errorEl = root.querySelector('[data-msc-cart-error]');
  var badge = root.querySelector('[data-msc-cart-count]');
  var fallbackError = root.getAttribute('data-error-text') || 'Something went wrong. Please try again.';
  var lastFocus = null;
  var pending = 0;

  // Keep the drawer a direct child of <body> so no ancestor transform or
  // overflow can break position: fixed.
  if (root.parentNode !== document.body) document.body.appendChild(root);

  function isOpen() { return root.classList.contains('is-open'); }

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.documentElement.classList.add('msc-cart-locked');
    fab.setAttribute('aria-expanded', 'true');
    // Wait for visibility to flip before moving focus in.
    requestAnimationFrame(function () {
      var closeBtn = sheet.querySelector('.msc-cart__close');
      (closeBtn || sheet).focus({ preventScroll: true });
    });
  }

  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('msc-cart-locked');
    fab.setAttribute('aria-expanded', 'false');
    hideError();
    var target = lastFocus && document.contains(lastFocus) ? lastFocus : fab;
    target.focus({ preventScroll: true });
  }

  function showError(message) {
    errorEl.textContent = message || fallbackError;
    errorEl.hidden = false;
  }

  function hideError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function setBusy(on) {
    pending += on ? 1 : -1;
    root.classList.toggle('is-busy', pending > 0);
  }

  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-msc-cart-contents]');
    if (!next) return;
    var current = body.querySelector('[data-msc-cart-contents]');
    if (current) { current.replaceWith(next); } else { body.appendChild(next); }

    var count = parseInt(next.getAttribute('data-count'), 10) || 0;
    var prev = parseInt(badge.textContent, 10) || 0;
    badge.textContent = count;
    badge.hidden = count === 0;
    if (count > prev) {
      fab.classList.remove('is-bumped');
      void fab.offsetWidth;
      fab.classList.add('is-bumped');
    }
    document.dispatchEvent(new CustomEvent('msc:cart:updated', { detail: { count: count } }));
  }

  // POST to a Cart API endpoint, asking for the drawer section back in the same
  // response. Rejects with the API's own message on 4xx (e.g. sold out).
  function post(endpoint, payload) {
    payload.sections = SECTION;
    payload.sections_url = window.location.pathname;
    setBusy(true);
    return fetch(rootUrl + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var err = new Error(data.description || data.message || fallbackError);
            err.cart = data;
            throw err;
          }
          return data;
        });
      })
      .then(function (data) {
        hideError();
        if (data.sections) render(data.sections[SECTION]);
        return data;
      })
      .finally(function () { setBusy(false); });
  }

  function refresh() {
    return fetch(rootUrl + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(data[SECTION]); });
  }

  // A failed add or change still leaves the cart in some state; show the
  // truth rather than whatever we optimistically assumed.
  function failAndRefresh(err) {
    showError(err && err.message);
    return refresh().catch(function () {}).then(function () { throw err; });
  }

  function add(items) {
    return post('cart/add.js', { items: items }).catch(failAndRefresh);
  }

  function change(key, quantity) {
    return post('cart/change.js', { id: key, quantity: quantity }).catch(failAndRefresh);
  }

  // ─── Events ───────────────────────────────────────────────────────────────
  fab.addEventListener('click', function () { isOpen() ? close() : open(); });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-msc-cart-close]')) { close(); return; }

    var item = e.target.closest('.msc-cart__item');
    if (!item) return;
    var key = item.getAttribute('data-key');
    var input = item.querySelector('[data-msc-cart-input]');

    if (e.target.closest('[data-msc-cart-remove]')) {
      change(key, 0).catch(function () {});
      return;
    }

    var step = e.target.closest('[data-msc-cart-qty]');
    if (step && input) {
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-msc-cart-qty'), 10));
      input.value = next;
      change(key, next).catch(function () {});
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-msc-cart-input]');
    if (!input) return;
    var item = input.closest('.msc-cart__item');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    change(item.getAttribute('data-key'), qty).catch(function () {});
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;

    // Keep focus inside the sheet while it is open.
    var focusable = Array.prototype.filter.call(
      sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusable.length) { e.preventDefault(); sheet.focus(); return; }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === sheet)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  // Coming Back from checkout restores this page from the bfcache with a stale
  // cart; re-render so the badge and drawer match what is really in the cart.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh().catch(function () {});
  });

  window.MSCCart = { open: open, close: close, refresh: refresh, add: add };
  document.dispatchEvent(new CustomEvent('msc:cart:ready'));
})();
